<template>
    <div class="grid-row" :style="{height:cellheight+'px'}" v-on:click="activateSpw">
    <div class="currentdate" :style="currentdate_indicator"></div>
      <div class="schedule-bar" v-if="row.spw.Start_Date_SPW" :style="bar_style">
         
        </div>

        <div :style="grid_style" class="cells-pattern">
        </div>
        <!-- <v-lazy :height="cellheight+'px'" :options="{rootMargin:'500px'}"> 
       <div class="cells" v-if="row.spw.Start_Date_SPW">
           <div v-for="datecell in date_range" v-bind:key="JSON.stringify(row.spw.ID&&datecell)" class="datecell" :class="{today: datecell.today}" :style="datecellstyle">
        </div></div>
         </v-lazy> -->
       <div class="noschedule" v-if="!row.spw.Start_Date_SPW" :style="{height: cellheight + 'px', width: grid_width + 'px'}"><div class="caption">This SPW is not scheduled. Add a start/end date.</div></div>
    </div>

</template>

<script>
// import Row from './Row';
// import Toolbar from './Toolbar';
import { mapState } from 'vuex'
import { mapGetters } from 'vuex'
// import { mapActions } from 'vuex'
// import { mapMutations } from 'vuex'
import { mapFields } from 'vuex-map-fields';
import Defer from '@/mixins/Defer'

  export default {
    props: ['row'],
    name: 'GridRow',
    components: {
    //   Row,
    },
    data: () => ({
  
    }),
    mixins: [
        Defer()
    ],
    computed: {
        ...mapState(['cellheight','cellwidth','moment','colors','moment']),
      ...mapGetters(['date_range','grid_width','width_to_today']),
      ...mapFields(['subproject_works','selection']),
      datecellstyle(){
          return {
              height: this.cellheight+'px',
              width: this.cellwidth+'px'
          }
      },
      thisSpw(){
          return this.subproject_works.find(s=>s.ID==this.row.spw.ID)
      },
      days_from_start(){
         
          return this.moment(this.row.spw.Start_Date_SPW).diff(this.date_range[0].value,'days')
      },
      
      currentdate_indicator(){
     
          let obj = {
            left: this.width_to_today + 'px',
              width: this.cellwidth + 'px'
              
          }
          return obj
      },

    bar_style(){
        let bgcolor = this.colors[0]
        if (this.row.spw.Foreman_SPW.ID){
        bgcolor = this.colors[this.row.spw.Foreman_SPW.ID]
        }
  
          return {
            width: (this.row.days*this.cellwidth)+'px', 
            left: (this.days_from_start*this.cellwidth) +"px", 
            height: this.cellheight/2+'px',
            top: this.cellheight/4+'px',
            backgroundColor: bgcolor
          }
      },
      grid_style(){
          return {
              width: this.grid_width+'px',
              height: this.cellheight+'px'
           
          }
      }
    },
    methods:{
        activateSpw(){
             document.getElementById('data_grid').scrollTo({left:this.days_from_start*this.cellwidth,behavior: 'smooth'})
            // document.getElementById('data_grid').scrollLeft = this.days_from_start*this.cellwidth
            // this.selection = this.thisSpw
        }
    }
  }

</script>
<style>
.currentdate{
    position: absolute;
    height: 100%;
    background-color:#E3F2FD;
    box-sizing: border-box;
        border-left: solid 3px #90CAF9;
    border-right: solid 3px #90CAF9;
    z-index: 0;
    border-bottom: solid 1px #90CAF9;
}
.cells{
    display:flex;
}
.cells-pattern{
  background: linear-gradient(90deg, #dfdfdf 1px, #fff 1px);
  background-size: 60px 60px;
  background-position: 0px 0px;
  border-bottom: solid 1px #dfdfdf;
  z-index:1;
}
.grid-row{
    box-sizing: border-box;
    position: relative;
}
.datecell{
    border-right: solid 1px #dfdfdf;
    border-bottom: solid 1px #dfdfdf;
    box-sizing: border-box;
    display:block;
    flex-shrink:0;
}
.schedule-bar{
    position:absolute;
}
.noschedule{
    border-bottom: solid 1px #cccccc;
    display:flex;
    align-items: center;
    padding-left: 10px;
}
.today{
    background-color:#E3F2FD;
    border-left: solid 3px #90CAF9;
    border-right: solid 3px #90CAF9;
}
</style>